import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { cn } from '~/lib/utils';
import { formControlClassName } from './form-control';

const StyledInput = styled.input`
	&::selection {
		background: hsl(var(--primary));
		color: hsl(var(--primary-foreground));
	}

	&::-moz-selection {
		background: hsl(var(--primary));
		color: hsl(var(--primary-foreground));
	}

	&:-webkit-autofill,
	&:-webkit-autofill:hover,
	&:-webkit-autofill:focus,
	&:-webkit-autofill:active {
		-webkit-text-fill-color: hsl(var(--foreground));
		-webkit-box-shadow: 0 0 0 1000px hsl(var(--background)) inset;
		transition: background-color 9999s ease-in-out 0s;
	}
`;

const Input = React.forwardRef(({ className, type = 'text', ...props }, ref) => {
	return (
		<StyledInput
			type={type}
			className={cn(
				formControlClassName,
				className
			)}
			ref={ref}
			{...props}
		/>
	);
});

Input.propTypes = {
	className: PropTypes.string,
	type: PropTypes.string
};

Input.displayName = 'Input';

export { Input };
